import {select as d3select} from 'd3-selection';
import * as geo from 'd3-geo';
import {geoRobinson} from 'd3-geo-projection';
import {scaleLinear} from 'd3-scale';
import {extent as d3extent} from 'd3-array';
import * as _ from 'underscore';

import State from '../State/State';
import Model from '../Model/Model';
import Dispatch from '../Dispatch/Dispatch';

import './DetailPanel.css';

var container = d3select('.RegionalMap-detail-panel');

var width = 360, height = 500;
var projection = geoRobinson()
  .scale(700)
  .translate([width / 2, height / 2])
  .center([40, -14])
  .precision(.1);

var geoGenerator = geo.geoPath()
  .projection(projection);

var countryTransform = {
	'Burundi': {center: [30, -4], scale: 7000},
	'Congo Democratic Republic': {center: [23, -9], scale: 800},
	'Ethiopia': {center: [40.7, 6], scale: 1250},
	'Kenya': {center: [38, -2], scale: 1700},
	'Malawi': {center: [35, -15], scale: 2100},
	'Mozambique': {center: [36, -22.5], scale: 950},
	'Rwanda': {center: [30, -2.5], scale: 7600},
	'Tanzania': {center: [35.2, -8.9], scale: 1400},
	'Uganda': {center: [32.5, 0], scale: 2800},
	'Zambia': {center: [28, -15.5], scale: 1500},
	'Zimbabwe': {center: [30, -20.5], scale: 2200}
}

var orange = '#DB8A33';

var choroplethScale = scaleLinear().domain([0, 65]).range(['#F8E8D7', orange]);

function init() {
	Dispatch.dispatch.on('selectedCountryUpdate.DetailPanel', update);
	Dispatch.dispatch.on('hoveredRegionUpdate.DetailPanel', updateHighlights);

	container
		.select('.RegionalMap-detail-panel-close')
		.on('click', () => {State.set('selectedCountry', null)})
}

function getCountryData(country) {
	var countryData = _.filter(Model.data, d => {
		return d.country === country
	})

	countryData = _.sortBy(countryData, 'burden').reverse()

	return countryData
}

function getRegionFeatures(country) {
	let features = _.filter(Model.regionsJson.features, d => {return d.properties.CNTRYNAMEE === country})
	return features
}

function enteringRow(d) {
	d3select(this)
		.append('td')
		.text(d.regionLabel);

	d3select(this)
		.append('td')
		.text(d.burden.toFixed(1));

	d3select(this)
		.on('mouseover', (d) => {onRegionMouseover(d.region)})
		.on('mouseout', onRegionMouseout)
}

function updateTable() {
	var countryName = State.selectedCountry
	var data = getCountryData(countryName)

	container
		.select('.RegionalMap-detail-panel-name')
		.text(countryName)

	var u = container
		.select('.RegionalMap-detail-panel-table .RegionalMap-detail-panel-table-content')
		.selectAll('tr')
		.data(data, d => {return d.country + '-' + d.region})

	u.enter()
		.append('tr')
		.each(enteringRow)

	u.exit()
		.remove()
}

function onRegionMouseover(region) {
	State.set('hoveredRegion', region)
}

function onRegionMouseout() {
	State.set('hoveredRegion', null)
}

function updateHighlights() {
	container
		.select('.RegionalMap-detail-panel-map svg')
		.selectAll('path')
		.style('stroke', d => {return d.properties.DHSREGEN === State.hoveredRegion ? '#444' : 'white' })
		.style('stroke-width', d => {return d.properties.DHSREGEN === State.hoveredRegion ? 1.5 : 1 })

	container
		.select('.RegionalMap-detail-panel-map svg')
		.selectAll('path')
		.filter(d => {return d.properties.DHSREGEN === State.hoveredRegion})
		.raise()

	container
		.select('.RegionalMap-detail-panel-table .RegionalMap-detail-panel-table-content')
		.selectAll('tr')
		.classed('highlighted', d => {return d.region === State.hoveredRegion})
}

function regionFill(d) {
	let country = d.properties['CNTRYNAMEE'];
	let region = d.properties['DHSREGEN'];
	return choroplethScale(Model.dataLU[country][region].burden)
}

function updateMap() {
	let countryName = State.selectedCountry

	// Update projection
	projection.scale(countryTransform[countryName].scale)
		.center(countryTransform[countryName].center)

	var features = getRegionFeatures(countryName)

	// Update choropleth scale
	let extent = d3extent(features, d => {return Model.dataLU[d.properties['CNTRYNAMEE']][d.properties['DHSREGEN']].burden})
	choroplethScale.domain(extent)

	var u = container
		.select('.RegionalMap-detail-panel-map svg')
		.selectAll('path')
		.data(features, d => {return d.properties.CNTRYNAMEE + '-' + d.properties.DHSREGEN})

	u
		.enter()
		.append('path')
		.attr('d', geoGenerator)
		.on('mouseover', (d) => {onRegionMouseover(d.properties.DHSREGEN)})
		.on('mouseout', onRegionMouseout)

		.merge(u)
		.style('fill', regionFill)
		.style('stroke', 'white')

	u.exit().remove()
}

function update() {
	container
		.style('display', State.selectedCountry === null ? 'none' : 'block')

	if(State.selectedCountry === null) return

	updateTable()
	updateMap()
}

var api = {
	init: init
};

export default api;




/** WEBPACK FOOTER **
 ** ./src/DetailPanel/DetailPanel.js
 **/